<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/basic/defectType/page" getKey="rows"
			:columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item class="noborder" :label="$t('yijiquexianleixingbianma')">
						<el-input disabled v-model="$attrs.type.code"></el-input>
					</el-form-item>
					<el-form-item class="noborder" :label="$t('yijiquexianleixingmingcheng')">
						<el-input disabled v-model="$attrs.type.name"></el-input>
					</el-form-item>
				</el-form>
			</template>
			<!-- 左侧按钮插槽 -->
			<template #buttonsL>
				<el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'w1');setDefaultValue()" type="primary">
					{{$t('xinzeng')}}
				</el-button>
			</template>
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('bianji', scope.row);setDefaultValue()">{{$t('bianji')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/basic/defectType/delete');setDefaultValue()">{{$t('shanchu')}}</el-button>
					</el-col>
				</el-row>
			</template>
		</yi_curd_table>

		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item  :label="$t('erjiquexianleixingbianma')" required>
						<el-input v-model.trim="yt.editObj.code"></el-input>
					</el-form-item>
					<el-form-item :label="$t('erjiquexianleixingmingcheng')" required>
						<el-input v-model="yt.editObj.name"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST','/web/basic/defectType/create', beforeAdd)"
						type="primary">{{$t('baocun')}}
					</el-button>
				</span>
			</template>
			<!-- 编辑 -->
			<template v-if="yt.editObj.action == 'bianji'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item class="noborder"  :label="$t('erjiquexianleixingbianma')" required>
						<el-input disabled v-model.trim="yt.editObj.code"></el-input>
					</el-form-item>
					<el-form-item :label="$t('erjiquexianleixingmingcheng')" required>
						<el-input v-model="yt.editObj.name"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST','/web/basic/defectType/update')"
						type="primary">{{$t('baocun')}}
					</el-button>
				</span>
			</template>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	export default {
		name: 'web_base_defect_defect_type_secondary',

		data() {
			return {
				columns: [{
						label: 'erjiquexianleixingbianma',
						prop: 'code',
						width: 150
					}, {
						label: 'erjiquexianleixingmingcheng',
						prop: 'name',
						width: 150
					},{
					label: 'chuangjianren',
					prop: 'createByObject.nickname'
				},
				{
					label: 'chuangjianshijian',
					prop: 'createTime',
					type: 'time',
					// format: 'YYYY-MM-DD HH:mm'
				}, 
					{
						label: 'caozuo',
						type: 'slot',
						width: 130,
						fixed: 'right'
					}
				]
			};
		},

		created() {
			setTimeout(() => {
				this.yt.conditions = {
					parentId: this.$attrs.type.id,
					level: 2
				}
				this.yt.get(1)
			}, 300)
		},
		methods: {
			setDefaultValue() {
				this.yt.editObj.level = 2;
			},
			beforeAdd(params, url) {
				params.parentId = this.$attrs.type.id
				return params
			}
		}
	};
</script>
